import React from 'react';
import UsersTable from 'Components/UsersView/usersTable';
import { observer } from 'mobx-react';
import { Navigate } from 'react-router-dom';
import AppStore from 'Stores/AppStore';
import UsersStore from 'Stores/usersStore';

class Users extends React.Component {
    componentDidMount() {
        AppStore.OnMainComponentMount('Список пользователей', 'users', this.ReloadData);

        this.ReloadData();
    }

    componentWillUnmount() {
        UsersStore.DropUserReloadState();
    }

    ReloadData() {
        UsersStore.ClearStoreForReload();
        UsersStore.GetInitData();
        UsersStore.UpdateUsers(null, null, false);
    }

    render() {
        if (this.props.migrationNeeded) {
            return (
                <Navigate to={`${window.SmrLocation}/migration`} />
            )
        }

        return (
            <UsersTable location={this.props.location} />
        );
    }
};

export default observer(Users);